"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueCountIcon = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_1 = __importDefault(require("react"));
const TriangleIcon_1 = __importDefault(require("../icons/TriangleIcon"));
function IssueCountIcon(props) {
    const { count, size = 16, margin, color = lib_palette_1.default.BadRed, textColor = lib_palette_1.default.White } = props;
    return (react_1.default.createElement(TriangleIcon_1.default, { size: size, color: color, margin: margin, otherChildren: react_1.default.createElement("text", { x: "50%", y: "62%", dominantBaseline: "middle", textAnchor: "middle", fill: textColor.main, fontSize: Math.min(Math.floor(size * 0.9), 14) }, count) }));
}
exports.IssueCountIcon = IssueCountIcon;
exports.default = IssueCountIcon;
